import {
  BadgePercent,
  Leaf,
  MapPin,
  MessageCircle,
  Navigation,
  Sparkles,
} from "lucide-react";

const FEATURES = [
  {
    icon: Leaf,
    title: "Relaxing Wellness Environment",
    description: "A calm, quiet space designed to help you slow down and switch off.",
  },
  {
    icon: Sparkles,
    title: "Multiple Massage Experiences",
    description: "Nine massage and wellness experiences to match your mood and preference.",
  },
  {
    icon: MapPin,
    title: "Convenient Singasandra Location",
    description: "Located in Vijayanand Residency, SBI Bank Building, Singasandra.",
  },
  {
    icon: Navigation,
    title: "Near Manipal County Road",
    description: "Easy to find and easy to reach, just off Manipal County Road.",
  },
  {
    icon: MessageCircle,
    title: "Easy WhatsApp Booking",
    description: "No forms, no waiting — book your slot in one WhatsApp message.",
  },
  {
    icon: BadgePercent,
    title: "New Spa Opening Offer",
    description: "Celebrate with us — flat 20% off during our opening period.",
  },
];

const WhyChoose = () => (
  <section id="why-us" className="scroll-mt-24 py-16 sm:py-24">
    <div className="mx-auto max-w-7xl px-4 sm:px-8">
      <div className="mx-auto max-w-2xl text-center">
        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[#9E7B36]">
          The GK Difference
        </p>
        <h2 className="mt-3 font-serif text-3xl font-medium tracking-tight text-[#1C1917] sm:text-4xl">
          Why Choose GK Wellness?
        </h2>
      </div>
      <div
        data-testid="why-choose-us-container"
        className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3"
      >
        {FEATURES.map(({ icon: Icon, title, description }) => (
          <div
            key={title}
            className="rounded-2xl border border-[#E7E2DA] bg-white p-6 shadow-[0_4px_20px_-2px_rgba(44,39,32,0.05)] transition-[box-shadow,transform] duration-300 hover:-translate-y-1 hover:shadow-[0_16px_32px_-4px_rgba(44,39,32,0.10)] sm:p-7"
          >
            <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-[#FDF9F0] ring-1 ring-[#C5A059]/30">
              <Icon className="h-6 w-6 text-[#9E7B36]" aria-hidden="true" />
            </span>
            <h3 className="mt-4 font-serif text-xl font-medium tracking-tight text-[#1C1917]">
              {title}
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-[#57534E]">{description}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default WhyChoose;
